import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import Notification from 'components/molecules/Notification';
import { getCoach, getCreationDateTime } from 'store/profile';
import { actionCreators as profileAC, getParticipateCompetition } from 'store/profile';
import { actionCreators as programAC } from 'store/programPreview';
import { IRootState } from 'store/rootReducer';
import { nullToUndefined } from 'utils/null-to-undefined';

const mapStateToProps = (state: IRootState) => ({
	coach: nullToUndefined(getCoach(state)),
	userCreationDateTimeStamp: getCreationDateTime(state),
	participateCompetition: nullToUndefined(getParticipateCompetition(state)) || false,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
	return bindActionCreators(
		{
			doStartProgram: programAC.doStartProgram,
			doOverwriteProgram: programAC.doOverwriteProgram,
			doReplaceProgram: programAC.doReplaceProgram,
			doSaveParticipateCompetition: profileAC.doSaveParticipateCompetition,
			doSaveDsgvo: profileAC.doSaveDsgvo,
		},
		dispatch
	);
};

export type NotificationContainerProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(Notification);
